<template>
  <div>
    <h2>Add note</h2>
    <p>
      Type note in box and click save to store on file. Date, time and user
      information will be recorded.
    </p>
    <v-textarea label="Note body" autofocus v-model="body" outline />
    <v-checkbox v-model="hide" label="hide note on tracker" />
    <v-checkbox
      v-model="copy"
      label="copy note to related file"
      v-if="related"
    />
    <v-checkbox v-model="share" label="send notification to conveyancer" />
    <v-btn @click="saveNote">Save</v-btn>
    <v-alert :value="feedback" type="error">{{ feedback }}</v-alert>
  </div>
</template>

<script>
export default {
  name: "Note",
  props: ["related"],
  data() {
    return {
      body: null,
      hide: false,
      copy: false,
      share: false,
      feedback: null
    };
  },
  methods: {
    saveNote() {
      if (!this.body || this.body == "") {
        this.feedback = "Note body cannot be empty";
        return;
      }
      this.feedback = null;
      this.$emit("create", {
        id: Number(this.$route.params.id),
        body: this.body,
        hide: this.hide,
        copy: this.copy,
        share: this.share
      });
    }
  }
};
</script>
